module.exports = __webpack_public_path__ + "static/media/gas.60fea09b.svg";